export const BASE_SERVICE_URL = process.env.REACT_APP_BASE_SERVICE_URL;
export const VALIDATE_PRODUCT = BASE_SERVICE_URL + 'api/product/v1/validate';
export const REFRESH_VALIDATED_TOKEN = BASE_SERVICE_URL + 'api/product/v1/refresh/token';
export const GET_PRODUCT_DETAILS = BASE_SERVICE_URL + 'api/product/v1/details';
export const GET_ASSOCIATED_GIFTS = BASE_SERVICE_URL + 'api/gift/v1/product';
export const GET_FORM_FIELDS = BASE_SERVICE_URL + 'api/form/v1';
export const GET_REGISTRATION_FORM_DETAILS = BASE_SERVICE_URL + 'api/form/v1/get/registration-form/';
export const GENERATE_EMAIL_VALIDATION_CODE = BASE_SERVICE_URL + 'api/verify/v1/generate-validation-code';
export const VALIDATE_EMAIL = BASE_SERVICE_URL + 'api/verify/v1/secure-validation';
export const SAVE_FORM = BASE_SERVICE_URL + 'api/form/v1/save';
export const CHECK_ACTIVE_RECORD = BASE_SERVICE_URL + 'api/verify/v1/check/record';
export const CHECK_REGISTRATION = BASE_SERVICE_URL + 'api/check/registration';
export const UPDATE_REGISTRATION = BASE_SERVICE_URL + 'api/registration/v1/update';
export const UPDATE_REGISTRATION_FILE = BASE_SERVICE_URL + 'api/registration/v1/update/file';
export const RESEND_FORGOTTEN_REFERENCE_NUMBER = BASE_SERVICE_URL + 'api/registration/v1/resend/certificate';
export const GET_FOOTER_CONFIG = BASE_SERVICE_URL + 'api/general/footer/config';
export const RESEND_EMAIL_VALIDATION_CODE = BASE_SERVICE_URL + 'api/verify/v1/resend-validation-code';
export const GET_APPLICATION_CONFIG = BASE_SERVICE_URL + 'api/application/v1/get/config/';
export const UPDATE_ONE_TRUST_CONFIG = BASE_SERVICE_URL + 'api/consent/update/';
export const GET_VALIDATION_TYPE = BASE_SERVICE_URL + 'api/verify/v1/type';
export const GET_LIVE_COUNTRIES_BY_BRAND = BASE_SERVICE_URL + 'api/gateway/live-countries/';
